module.exports = __webpack_public_path__ + "static/media/pdf-receipt.0edf2acd.svg";